/**
 * Enum for YES/NO question option values.
 * These values match the backend Java YesNoQuestionOption enum
 * to ensure consistency across the application.
 */
export enum YesNoOptionValue {
  YES = '1',
  NO = '0',
  NOT_SURE = '2',
  MAYBE = '3',
}

/**
 * Admin IDs for YES/NO question checkboxes
 */
export enum YesNoOptionAdminId {
  YES = 'yes',
  NO = 'no',
  NOT_SURE = 'not-sure',
  MAYBE = 'maybe',
}
